// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteDialogContainer-module_footer_M_qxz {
  margin-top: 0 !important;
  width: 100%;
  justify-items: end !important;
}

.SiteDialogContainer-module_close_button_QdyWi {
}`, "",{"version":3,"sources":["webpack://./src/client/components/SiteDialogContainer/SiteDialogContainer.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;AAGA","sourcesContent":[".footer {\n  margin-top: 0 !important;\n  width: 100%;\n  justify-items: end !important;\n}\n\n.close_button {\n  composes: secondary_button from 'Styles/styles.module.css';\n  composes: secondary_outlined from 'Styles/styles.module.css';\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `SiteDialogContainer-module_footer_M_qxz`,
	"close_button": `SiteDialogContainer-module_close_button_QdyWi ${___CSS_LOADER_ICSS_IMPORT_0___.locals["secondary_button"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["secondary_outlined"]}`
};
export default ___CSS_LOADER_EXPORT___;
